import { ViewHook } from "phoenix_live_view";

class CenterSelected extends ViewHook {
  private clickHandlers?: Map<HTMLElement, (event: Event) => void>;

  mounted() {
    this.clickHandlers = new Map();

    this.setupCenterableElements();
    this.centerInitialElement();
  }

  updated() {
    this.setupCenterableElements();
  }

  destroyed() {
    this.clickHandlers?.forEach((handler, element) => {
      element.removeEventListener("click", handler);
    });
    this.clickHandlers?.clear();
  }

  private setupCenterableElements() {
    const centerableElements = this.el.querySelectorAll<HTMLElement>("[data-centerable]");

    centerableElements.forEach((element) => {
      // Remove existing listener if it exists
      const existingHandler = this.clickHandlers?.get(element);
      if (existingHandler) {
        element.removeEventListener("click", existingHandler);
      }

      // Create and add new click handler
      const handler = () => this.centerElement(element);
      element.addEventListener("click", handler);
      this.clickHandlers?.set(element, handler);
    });
  }

  private centerInitialElement() {
    const selectedElement = this.el.querySelector(
      "[data-centerable][data-selected]",
    ) as HTMLElement;

    if (selectedElement) {
      this.centerElement(selectedElement, false);
    }
  }

  private centerElement(element: HTMLElement, smooth = true) {
    const container = this.el;

    // Get the container's dimensions and scroll position
    const containerRect = container.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();

    // Calculate the element's position relative to the container (x-direction only)
    const elementLeft = elementRect.left - containerRect.left + container.scrollLeft;

    // Calculate the center position (horizontal only)
    const centerX = elementLeft + element.offsetWidth / 2 - container.clientWidth / 2;

    // Scroll to center the element horizontally
    container.scrollTo({
      left: Math.max(0, centerX),
      behavior: smooth ? "smooth" : "auto",
    });
  }
}

export default CenterSelected;
